'use client';

import type { NextPage } from 'next'
import React, { useEffect, useState } from 'react'
import * as notifManager from 'firebaseConfig/notificationsManger'
import { addNotificationsToReducer } from 'actions/general'
import { useAppDispatch, useAppSelector } from 'reducers/storeHooks'

interface Props {
  children: React.ReactNode
}
const NotificationsManager: NextPage<Props> = ({ children }) => {
  const dispatch = useAppDispatch()
  const myUid = useAppSelector(state => state?.userReducer?.user?.uid)

  useEffect(() => {
    if (!myUid) return;
    let unsub: any;
    const getNotifications = async () => {
      unsub = await notifManager.getMyNotifications(myUid, (notifications: any) => {
        notifications && dispatch(addNotificationsToReducer(notifications))
      });
    };

    getNotifications();

    return () => {
      if (typeof unsub === 'function') {
        unsub();
      }
    } 

  }, [])

  return (<>
    {children}
  </>
  )
}
export default NotificationsManager